import React from "react";
import { IconData } from "lib/api";
import { getImageVideoUrl } from "lib/utils/url";

interface IconProps {
  iconData: IconData;
  color?: string;
}

const COLOR_SIZE = "15px";

const Icon: React.FC<IconProps> = ({ iconData, color: colorProp }) => {
  const { icon_type: iconType, icon } = iconData;

  const color = colorProp ?? "#414141";

  if (!icon) return null;

  const styles = {
    width: COLOR_SIZE,
    height: COLOR_SIZE,
  };

  switch (iconType) {
    case "fontawesome":
      return <div className={`fa fa-${icon}`} style={{ color }} />;
    case "attachment_id":
      return <img alt="" style={styles} src={getImageVideoUrl(icon)} />;
    case "url":
      return <img alt="" style={styles} src={icon} />;

    default:
      return null;
  }
};

export default React.memo(Icon);
